import React from 'react';
import { useTranslation } from 'react-i18next';
import { Spinner, MainTitle } from '../../../../common/index.jsx';
import { useGetDissertationDetailQuery } from '../../../../../redux/services/dissertations.jsx';
import PhDShowDetail from './DissertationShowDetail.jsx';
import { useParams } from 'react-router-dom';
import useScrollToTopOnMount from '../../../../../hooks/useScrollToTopOnMount.jsx';

const DissertationDetailPage = () => {
  useScrollToTopOnMount();
  const { t } = useTranslation();
  const { id } = useParams();

  const { data: dissertationDetail, isLoading: isLoadingDissertation } =
    useGetDissertationDetailQuery(id);

  return (
    <>
      <MainTitle title={t('Detail dizertačnej práce')} backAction={true} />

      {isLoadingDissertation ? (
        <Spinner />
      ) : (
        <PhDShowDetail dissertationDetail={dissertationDetail} />
      )}
    </>
  );
};

export default DissertationDetailPage;
